import { rem } from 'polished';
import { css } from 'styled-components';

import { breakpoints, misc } from 'helpers/styles/constants';

const verticalPadding = (value: number) => css`
  padding-left: ${rem(value)};
  padding-right: ${rem(value)};
`;

export const pagePadding = css`
  ${verticalPadding(misc.dashboardPaddingSm)};

  @media ${breakpoints.smUp} {
    ${verticalPadding(misc.dashboardPadding)};
  }

  @media ${breakpoints.lgUp} {
    ${verticalPadding(misc.dashboardPaddingLg)};
  }

  @media ${breakpoints.xlUp} {
    ${verticalPadding(misc.dashboardPaddingXl)};
  }
`;
